import * as mock from "./mock";
import { create } from "../UtilsOld";

const Service = {};
const option = [
    /**
     * 新增
     * @param { JSON } 成果对象
     */
    ["add", "/v1/user/chengguo", "post", true],
    /**
     * 修改
     * @param { Array } ids 成果标识列表
     */
    ["update", "/v1/user/chengguo", "put", true],
    /**
     * 删除
     * @param { Array } ids 成果标识列表
     */
    ["delete", "/v1/user/chengguo", "delete", true],
    /**
     * 审核
     * @param { Array } ids 成果标识列表
     * @param { Number } status 审核状态（2 驳回 3 审核）
     * @param { String } reason 审核原由
     */
    ["audit", "/v1/user/chengguo/audit", "post", true],
    /**
     * 成果列表
     * @param { Number } scopeId 领域 ID
     * @param { Number } pageIndex 页码
     * @param { Number } pageSize 每页条数
     * @param { Number } sort 排序（1 综合 2 最新 3 最热）
     */
    ["list", "/v1/chengguo/list", "get", true],
    /**
     * 成果列表
     * @param { Number } scopeId 领域 ID
     * @param { Number } pageIndex 页码
     * @param { Number } pageSize 每页条数
     * @param { Number } sort 排序（1 综合 2 最新 3 最热）
     */
    ["myList", "/v1/user/chengguo/list", "get", true],
    /**
     * 成果列表
     * @param { Number } scopeId 领域 ID
     * @param { Number } pageIndex 页码
     * @param { Number } pageSize 每页条数
     * @param { Number } sort 排序（1 综合 2 最新 3 最热）
     */
    ["myListArr", "/v1/user/chengguo/list2", "get", true],
    /**
     * 成果列表
     * @param { Number } scopeId 领域 ID
     * @param { Number } pageIndex 页码
     * @param { Number } pageSize 每页条数
     * @param { Number } sort 排序（1 综合 2 最新 3 最热）
     */
    ["auditList", "/v1/chengguo/audit/list", "get", true],
    /**
     * 根据服务状态查询成果
     * @param { String } keyword 关键字
     * @param { Number } serviceStatus 服务状态（1 全部 2 未提供服务）
     * @param { Number } pageIndex 页码
     * @param { Number } pageSize 每页条数
     */
    ["resultListByServiceStatus", "/user/chengguo/service/list", "get", true],
    /**
     * 发布成果
     * @param { JSON } 成果对象
     */
    ["addResult", "/user/chengguo", "post", true],
    /**
     * 成果详情
     * @param { Number } chengguoId 成果 ID
     */
    ["resultDetail", "/v1/chengguo/detail", "get", true],
    ["detail", "/v1/chengguo/detail", "get", true],
    /**
     * 成果相关需求列表
     * @param { Number } id 成果 ID
     */
    ["resultMatchList", "/chengguo/match/list", "get", true],
    /**
     * 成果列表
     * @param { Number } scopeId 领域 ID
     * @param { Number } pageIndex 页码
     * @param { Number } pageSize 每页条数
     * @param { Number } sort 排序（1 综合 2 最新 3 最热）
     */
    ["resultList", "/chengguo/list", "get", true],
    /**
     * 成果列表
     */
    ["resultTypeList", "/chengguo/type/list", "get", true],
    /**
     * 成果推荐列表
     * @param { Number } pageIndex 页码
     * @param { Number } pageSize 每页条数
     */
    ["recommendList", "/chengguo/recommend/list", "get", true],
    /**
     * 匹配列表
     * @param { String } xuqiuId id
     * @param { Number } pageIndex 页码
     * @param { Number } pageSize 每页条数
     */
    ["match", "/v1/chengguo/match", "get", true],
    /**
     * 分类统计
     * API http://116.255.247.58:3000/project/17/interface/api/31
     * @param { String } areaCode 区域编码
     * @param { Number } level 区域级别 1:省,2:地市,3:区县
     */
    ["scopeStatistics", "/v1/chengguo/cat/statistics", "get", true],
    /**
     * 周期统计
     * API http://116.255.247.58:3000/project/17/interface/api/31
     * @param { String } areaCode 区域编码
     * @param { Number } level 区域级别 1:省,2:地市,3:区县
     */
    ["dateNumStatistics", "/v1/chengguo/default/statistics", "get", true],
]

create(option, Service, mock)

export default {
    Service,
    option
};
